import { FLOW_NODE_TYPES } from '@sonar-software/sonar-ts-constants';
import { SfNodeType } from '@sonar-software/sonar-ts-types';

const flowNodeTypeMap: Record<string, string> = {
	[ SfNodeType.Decisions ]: FLOW_NODE_TYPES.DECISION,
	[ SfNodeType.RecordCreates ]: FLOW_NODE_TYPES.RECORD_CREATE,
	[ SfNodeType.RecordLookups ]: FLOW_NODE_TYPES.RECORD_LOOKUP,
	[ SfNodeType.RecordUpdates ]: FLOW_NODE_TYPES.RECORD_UPDATE
};

export function mapFlowNodeType(nodeType: string | null | undefined): string | null | undefined {
	if (!nodeType) {
		return nodeType;
	}

	return flowNodeTypeMap[ nodeType ] ?? nodeType;
}
